import { render } from "./App.vue?vue&type=template&id=296cad66"
const script = {}

import "./App.vue?vue&type=style&index=0&id=296cad66&lang=scss"

import exportComponent from "/builds/anisen/datamanagerweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__